<template>
  <div>
    <div class="app-content content">
      <div class="content-overlay"></div>
      <div class="content-wrapper">
        <div class="content-header row"></div>
        <div class="content-body">
          <section class="row flexbox-container">
            <div class="col-xl-8 col-10">
              <div class="card bg-authentication mb-0">
                <div class="row m-0">
                  <div class="col-md-6 col-12 px-0">
                    <div
                      class="card disable-rounded-right mb-0 p-2 h-100 d-flex justify-content-center"
                    >
                      <div class="card-header pb-1">
                        <div class="card-title">
                          <div class="text-center">
                            <h2>
                              <img
                                src="@/app-assets/images/brand/pacto-logo.png"
                                alt="Pacto Logo"
                                style="width: 160px"
                              />
                            </h2>
                          </div>
                        </div>
                      </div>
                      <div class="card-content">
                        <div class="card-body">
                          <div class="divider">
                            <div class="divider-text text-uppercase text-muted">
                              <small>{{$t('You need an invitation to sign up')}}</small>
                            </div>
                          </div>
                          <div class="text-center" v-if="error == 'required'">
                            <p class="text-danger">
                              {{$t('Password field is')}} <strong>{{$t('required')}}</strong> 😕
                            </p>
                          </div>
                          <div
                            class="text-center"
                            v-if="error == 'email-or-phone'"
                          >
                            <p class="text-danger">
                              {{$t('Email field is')}} <strong>{{$t('required')}}</strong> 😕
                            </p>
                          </div>
                          <div class="text-center" v-if="error == 'invite'">
                            <p class="text-danger">
                              {{$t('You')}} <strong>{{$t('need an invitation')}}</strong> {{$t('to sign up')}}
                              😕
                            </p>
                          </div>
                          <div class="text-center" v-if="error == 'exists'">
                            <p class="text-danger">
                              {{$t('An account with this email')}}
                              <strong>{{$t('already exists')}}</strong>. {{$t('Please execute  login!')}}
                            </p>
                          </div>
                          <div
                            class="text-center"
                            v-if="error == 'bad request'"
                          >
                            <p class="text-danger">{{ errorMessage }}</p>
                          </div>
                          <div
                            class="text-center"
                            v-if="error == 'password length'"
                          >
                            <p class="text-danger">
                              {{$t('Your password must be')}}
                              <strong>{{$t('15 characters')}}</strong> {{$t('or more')}}
                            </p>
                          </div>
                          <form>
                            <div class="form-row">
                              <div class="form-group col-md-6 mb-50">
                                <label for="inputfirstname4">{{$t('first name')}}</label>
                                <input
                                  type="text"
                                  class="form-control"
                                  id="inputfirstname4"
                                  placeholder="John"
                                  v-model="firstName"
                                />
                              </div>
                              <div class="form-group col-md-6 mb-50">
                                <label for="inputlastname4">{{$t('last name')}}</label>
                                <input
                                  type="text"
                                  class="form-control"
                                  id="inputlastname4"
                                  placeholder="Doe"
                                  v-model="lastName"
                                />
                              </div>
                            </div>
                            <div class="form-group mb-50">
                              <label
                                class="text-bold-600"
                                for="exampleInputEmail1"
                                >{{$t('Email address')}}</label
                              >
                              <input
                                type="email"
                                class="form-control"
                                id="exampleInputEmail1"
                                placeholder="johndoe@example.com"
                                v-model="emailAddress"
                                autocomplete="off"
                              />
                            </div>
                            <div class="form-group mb-50">
                              <label
                                class="text-bold-600"
                                for="exampleInputEmail1"
                                >{{$t('Phone Number')}}</label
                              >
                              <input
                                type="tel"
                                id="phoneNumber"
                                class="form-control"
                                v-model="invitePhoneNumber"
                              />
                            </div>
                            <div class="form-group mb-2">
                              <label
                                class="text-bold-600"
                                for="exampleInputPassword1"
                                >{{$t('Password')}}</label
                              >
                              <input
                                type="password"
                                class="form-control"
                                id="exampleInputPassword1"
                                :placeholder="$t('Password')"
                                v-model="password"
                                autocomplete="off"
                              />
                              <small
                                >{{$t('You must keep your password secret. Do not use  your Organisation password outside official Organisation  services')}}</small
                              >
                            </div>
                            <button
                              type="button"
                              class="btn btn-primary glow position-relative w-100"
                              @click="signUp()"
                              v-if="!loggingIn"
                            >
                              {{$t('SIGN UP')}}
                              <em
                                id="icon-arrow"
                                class="bx bx-right-arrow-alt"
                              ></em>
                            </button>
                            <button
                              disabled
                              type="submit"
                              class="btn btn-primary glow w-100 position-relative"
                              v-else
                            >
                              <span
                                class="spinner-border spinner-border-sm"
                                role="status"
                                aria-hidden="true"
                              ></span>
                              <span class="sr-only">{{$t('Loading...')}}</span>
                            </button>
                          </form>
                          <hr />
                          <div class="text-center">
                            <small class="mr-25"
                              >{{$t('Already have an account?')}}</small
                            >
                            <router-link :to="{ name: 'LoginPage' }">
                              <small>{{$t('Sign In')}}</small>
                            </router-link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-md-6 d-md-block d-none text-center align-self-center p-3"
                  >
                    <lottie-player
                      src="https://assets4.lottiefiles.com/packages/lf20_fwykef3x.json"
                      background="transparent"
                      speed="1"
                      style="width: 100%; height: auto"
                      loop
                      autoplay
                    ></lottie-player>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      phoneNumberObj: null,
      invitePhoneNumber: "",
      firstName: "",
      lastName: "",
      emailAddress: "",
      password: "",
      loggingIn: false,
      error: "",
      errorMessage: "",
    };
  },

  methods: {
    initTelInput() {
      let input = document.querySelector("#phoneNumber");
      this.phoneNumberObj = intlTelInput(input);
    },

    signUp() {
      let self = this;
      let countryData = this.phoneNumberObj.getSelectedCountryData();
      let pN =
        "+" +
        countryData.dialCode +
        this.invitePhoneNumber.replace(`+${countryData.dialCode}`, "");
      let name = `${this.firstName} ${this.lastName}`;

      this.loggingIn = false;
      this.error = "";
      this.errorMessage = "";

      if (this.emailAddress.trim() == "") {
        this.error = "email-or-phone";
      } else {
        if (this.password.trim() != "") {
          if (this.password.length < 15) {
            this.error = "password length";
            return;
          }

          this.loggingIn = true;

          let body = {
            name: name,
            email: this.emailAddress,
            password: this.password,
          };

          if (this.invitePhoneNumber != "") {
            body.phoneNumber = pN;
          }

          this.$apiCall
            .post("/v1/auth/signup/admin", body)
            .then((response) => {
              this.loggingIn = false;
              location.href = "/login";
            })
            .catch((error) => {
              this.loggingIn = false;
              if (error.response.status == 404) {
                this.error = "invite";
              } else if (error.response.status == 405) {
                this.error = "exists";
              } else if (error.response.status == 400) {
                this.error = "bad request";
                this.errorMessage = error.response.data.message.join(", ");
              }
            });
        } else {
          this.error = "required";
        }
      }
    },
  },

  watch: {
    invitePhoneNumber: function (value) {
      this.invitePhoneNumber = value.replace(/[^\d|\-+]/g, "");
    },
  },

  mounted() {
    $("body").removeClass(
      "vertical-layout vertical-menu-modern 2-columns navbar-sticky footer-static"
    );
    $("body").addClass(
      "vertical-layout vertical-menu-modern 1-column navbar-sticky footer-static bg-full-screen-image blank-page blank-page"
    );
    this.initTelInput();
  },
};
</script>